import React from 'react'
import {
  StyledHeader,
  StyledHeaderRight,
  StyledLogo,
  StyledAdminHeaderRight,
} from "./style";
import { FaSignOutAlt } from "react-icons/fa";
import { logout } from "../../../../redux/authSlice";
import { useDispatch } from "react-redux";

import Dropdown from "react-bootstrap/Dropdown";
import AdminLogo from "../../../../assets/images/saudi-arabia.png"
import User from "../../../../assets/images/user.png"

const AdminNavbar = () => {
  const dispatch = useDispatch();
  const handleLogout = (e) => {
   e.preventDefault();
    localStorage.removeItem("user");
    dispatch(logout());
  };
  return (
    <StyledHeader>
      <div className="toggle-button-box">
        <button
          type="button"
          className="toggle-button"
         
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <StyledLogo>
        <img src={AdminLogo} alt="Logo" />
      </StyledLogo>
      <StyledHeaderRight>
        <StyledAdminHeaderRight>
          <ul>
            <li className="dropdown">
              <span className="admin-name">{`Welcome ${"Admin"}`}</span>
              <div className="user-top">
                <span className="online"></span>
                <span className="user-img">
                  <img src={User} alt="user" />
                </span>
              </div>
              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="dropdown-toggle"
                >
                  {" "}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#" onClick={handleLogout}>
                    {" "}
                    <FaSignOutAlt className="logout-icons" />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </StyledAdminHeaderRight>
      </StyledHeaderRight>
    </StyledHeader>
  )
}

export default AdminNavbar